"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineHeight = exports.Size = exports.FontWeight = exports.FontFamily = void 0;
const colors_1 = __importDefault(require("../colors"));
var FontFamily;
(function (FontFamily) {
    FontFamily["Primary"] = "\"GT Eesti Display\", sans-serif";
    FontFamily["Secondary"] = "\"Spectral\", serif";
})(FontFamily = exports.FontFamily || (exports.FontFamily = {}));
var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Regular"] = 400] = "Regular";
    FontWeight[FontWeight["Bold"] = 600] = "Bold";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));
var Size;
(function (Size) {
    Size["H1"] = "96px";
    Size["H2"] = "72px";
    Size["H3"] = "60px";
    Size["H4"] = "48px";
    Size["Larger"] = "32px";
    Size["Large"] = "24px";
    Size["Main"] = "18px";
    Size["Small"] = "14px";
    Size["Smaller"] = "12px";
})(Size = exports.Size || (exports.Size = {}));
var LineHeight;
(function (LineHeight) {
    LineHeight[LineHeight["H1"] = 1.1] = "H1";
    LineHeight[LineHeight["H2"] = 1.05] = "H2";
    LineHeight[LineHeight["H3"] = 1.15] = "H3";
    LineHeight[LineHeight["H4"] = 1.15] = "H4";
    LineHeight[LineHeight["Larger"] = 1.15] = "Larger";
    LineHeight[LineHeight["Large"] = 1.15] = "Large";
    LineHeight[LineHeight["Main"] = 1.2] = "Main";
    LineHeight[LineHeight["Small"] = 1.2] = "Small";
    LineHeight[LineHeight["Smaller"] = 1.2] = "Smaller";
    LineHeight[LineHeight["Secondary"] = 1.4] = "Secondary";
})(LineHeight = exports.LineHeight || (exports.LineHeight = {}));
const defaults = {
    fontWeight: FontWeight.Regular,
    color: colors_1.default.text.primary,
};
const primary = {
    h1: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.H1, lineHeight: LineHeight.H1 }, defaults),
    h2: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.H2, lineHeight: LineHeight.H2 }, defaults),
    h3: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.H3, lineHeight: LineHeight.H3 }, defaults),
    h4: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.H4, lineHeight: LineHeight.H4 }, defaults),
    larger: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.Larger, lineHeight: LineHeight.Larger }, defaults),
    large: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.Large, lineHeight: LineHeight.Large }, defaults),
    main: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.Main, lineHeight: LineHeight.Main }, defaults),
    small: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.Small, lineHeight: LineHeight.Small }, defaults),
    smaller: Object.assign({ fontFamily: FontFamily.Primary, fontSize: Size.Smaller, lineHeight: LineHeight.Smaller }, defaults),
};
const secondary = {
    larger: Object.assign({ fontFamily: FontFamily.Secondary, fontSize: Size.Larger, lineHeight: LineHeight.Secondary, letterSpacing: `-${parseInt(Size.Larger, 10) * 0.04}px` }, defaults),
    large: Object.assign({ fontFamily: FontFamily.Secondary, fontSize: Size.Large, lineHeight: LineHeight.Secondary, letterSpacing: `-${parseInt(Size.Large, 10) * 0.04}px` }, defaults),
    main: Object.assign({ fontFamily: FontFamily.Secondary, fontSize: Size.Main, lineHeight: LineHeight.Secondary, letterSpacing: `-${parseInt(Size.Main, 10) * 0.04}px` }, defaults),
    small: Object.assign({ fontFamily: FontFamily.Secondary, fontSize: Size.Small, lineHeight: LineHeight.Secondary, letterSpacing: `-${parseInt(Size.Small, 10) * 0.04}px` }, defaults),
    smaller: Object.assign({ fontFamily: FontFamily.Secondary, fontSize: Size.Smaller, lineHeight: LineHeight.Secondary, letterSpacing: `-${parseInt(Size.Smaller, 10) * 0.04}px` }, defaults),
};
exports.default = {
    FontFamily,
    FontWeight,
    Size,
    LineHeight,
    variants: {
        primary,
        secondary,
    },
};
//# sourceMappingURL=typography.js.map